export default function getAnimalLabel(
  id = 1,
  houseName = "",
  zimsId = "",
  localId = "",
  tag = ""
) {
  if (houseName && zimsId && localId && tag) {
    return `${houseName} (ZIMS: ${zimsId})(LocalId: ${localId})[${
      tag?.split("\n")?.[0]
    }]`;
  }

  if (houseName && zimsId && tag) {
    return `${houseName} (ZIMS: ${zimsId})[${tag?.split("\n")?.[0]}]`;
  }

  if (houseName && localId && tag) {
    return `${houseName} (LocalId: ${localId})[${tag?.split("\n")?.[0]}]`;
  }

  if (houseName && zimsId && localId) {
    return `${houseName} (ZIMS: ${zimsId})(LocalId: ${localId})`;
  }

  if (houseName && localId) {
    return `${houseName} (LocalId: ${localId})`;
  }

  if (houseName && zimsId) {
    return `${houseName} (ZIMS: ${zimsId})`;
  }

  if (houseName && tag) {
    return `${houseName} [${tag?.split("\n")?.[0]}]`;
  }

  if (zimsId && localId && tag) {
    return `${tag?.split("\n")?.[0]} (ZIMS: ${zimsId})(LocalId: ${localId})`;
  }

  if (zimsId && tag) {
    return `${tag?.split("\n")?.[0]} (ZIMS: ${zimsId})`;
  }

  if (localId && tag) {
    return `${tag?.split("\n")?.[0]} (LocalId: ${localId})`;
  }

  if (houseName) {
    return houseName;
  }

  if (tag) {
    return tag?.split("\n")?.[0];
  }

  if (zimsId && localId) {
    return `(ZIMS: ${zimsId})(LocalId: ${localId})`;
  }

  if (localId) {
    return `(LocalId: ${localId})`;
  }

  if (zimsId) {
    return `(ZIMS: ${zimsId})`;
  }

  return `Anonyme (ID: ${id})`;
}
